// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OtherTiles_wrapper___NCGO","section":"OtherTiles_section__W1Ea9","title":"OtherTiles_title__QS7oi"};